export const invoices = (state) => state.invoices
export const invoice = (state) => state.invoice
export const invoiceLines = (state) => state.invoiceLines
export const invoiceDeletedItems = (state) => state.invoiceDeletedItems
export const invoiceAccountEntries = (state) => state.invoiceAccountEntries
export const workingInvoice = (state) => state.workingInvoice
export const payments = (state) => state.payments
